module.exports = __webpack_public_path__ + "img/icon_sound.d82138ab.svg";